import axios, { AxiosError } from 'axios';
import { ShowMessage } from '../hooks/snackbar.hook';
import {
    ERROR_MESSAGE_GENERIC,
    ERROR_MESSAGE_NO_NETWORK,
    ERROR_MESSAGE_TIMEOUT,
    HTTP_ACCESS_DENIED,
    HTTP_BAD_REQUEST,
    HTTP_CODE_BROKEN_NETWORK,
    HTTP_CODE_NOT_FOUND,
    HTTP_CODE_TIMEOUT,
    HTTP_CONFLICT,
} from './constants.util';

/**
 * Récupération du contenu d'une page grâce à son code
 * Attribut : key => string
 **/
export const showAxiosMessageError = (error: Error | AxiosError, showMessage: ShowMessage) => {
    if (axios.isAxiosError(error)) {
        //On met en cancel un appel quand le token est expiré
        if ('ERR_CANCELED' === error?.code) {
            showMessage.infoAlert(error.message);
        } else if (error?.response?.status === HTTP_CODE_NOT_FOUND) {
            console.warn('Erreur 404 : ', error.response.data);
        } else {
            let message;
            switch (error?.response?.status) {
                // httpCodeInvalidInputs : retours champs formulaire
                case HTTP_CONFLICT:
                    message = error.response.data.message;
                    break;
                // httpCodeInvalidInputs : retours champs formulaire avec règles (exemple : mdp)
                case HTTP_BAD_REQUEST:
                    message = error.response.data.message;
                    break;
                // Autres erreurs plus simples
                case HTTP_ACCESS_DENIED:
                    message = error.response.data.message;
                    break;
                default:
                    message = ERROR_MESSAGE_GENERIC;
                    break;
            }
            // si on a un code httpCodeBrokenNetwork il prime sur tout le reste
            if (error?.code === HTTP_CODE_BROKEN_NETWORK) {
                message = ERROR_MESSAGE_NO_NETWORK;
            }
            if (error?.code === HTTP_CODE_TIMEOUT) {
                message = ERROR_MESSAGE_TIMEOUT;
            }
            //Affichage de l'erreur
            showMessage.errorAlert(message);
        }
    } else {
        //Affichage de l'erreur
        showMessage.errorAlert(ERROR_MESSAGE_GENERIC);
    }
};
